"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useEffect } from 'react';
import { useComboBox } from './use-combobox.mjs';
import { ComboBoxDropdownSearchContext } from './use-combobox-dropdown-search.mjs';

const ComboBoxDropdownSearchProvider = ({
  children,
  hideSearch = false
}) => {
  const [dropdownSearchInputValue, setDropdownSearchInputValue] = useState("");
  const [searchSource, setSearchSource] = useState(
    "indeterminate"
  );
  const { isDropdownOpen } = useComboBox();
  const contextValue = useMemo(
    () => ({
      dropdownSearchInputValue,
      setDropdownSearchInputValue,
      hideSearch,
      searchSource,
      setSearchSource
    }),
    [dropdownSearchInputValue, hideSearch, searchSource]
  );
  useEffect(() => {
    if (!isDropdownOpen && dropdownSearchInputValue) {
      setDropdownSearchInputValue("");
    }
  }, [isDropdownOpen]);
  return /* @__PURE__ */ jsx(ComboBoxDropdownSearchContext.Provider, { value: contextValue, children });
};

export { ComboBoxDropdownSearchProvider };
